<script setup lang="ts">
import { IGenericSchoolClass } from '@/interfaces';
import EntityAppearance from '@/core/entity-appearance/EntityAppearance.vue';
import { appearanceFromDto } from '@/core/entity-appearance/appearanceFromDto';
import { ref, useTemplateRef, watch } from 'vue';

defineProps<{
  schoolClass: IGenericSchoolClass | null;
  editable?: boolean;
  size?: 'small';
}>();

const model = defineModel<string>({ default: '' });
const currentValue = ref('');
const inputRef = useTemplateRef('inputRef');

function updateCurrentValue(): void {
  currentValue.value = model.value;
}

function handleBlur(): void {
  emitChanges();
}

function emitChanges(): void {
  model.value = currentValue.value;
}

watch(() => model.value, updateCurrentValue, {
  immediate: true,
});
</script>

<template>
  <EntityAppearance
    v-if="!editable"
    :appearance="appearanceFromDto(schoolClass?.appearance)"
    :abbreviation="schoolClass?.name || model || '-'"
    :size="size === 'small' ? 'md' : 'lg'"
    :class="size === 'small' ? '!size-icon-xl' : '!size-cell'"
  />
  <input
    v-else-if="editable"
    ref="inputRef"
    v-model="currentValue"
    name="className"
    class="font-semibold rounded-md border border-divider bg-white text-center size-cell"
    maxlength="4"
    @blur="handleBlur"
    @keydown.enter="inputRef?.blur()"
  />
</template>
